import { useMemo } from "react";
import * as THREE from "three";

/** Default outline color: a warm near-black, not pure black, to stay on-palette. */
export const OUTLINE_COLOR = "#2B2118";

const VERTEX_SHADER = /* glsl */ `
  uniform float thickness;
  void main() {
    vec3 displaced = position + normal * thickness;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(displaced, 1.0);
  }
`;

const FRAGMENT_SHADER = /* glsl */ `
  uniform vec3 outlineColor;
  void main() {
    gl_FragColor = vec4(outlineColor, 1.0);
  }
`;

/**
 * Inverted-hull outline material: a second mesh sharing the same geometry,
 * rendered BackSide with vertices pushed out along their normals. Cheaper
 * and chunkier than a post-process edge pass, per the M1a plan.
 */
export function useOutlineMaterial(color: string = OUTLINE_COLOR, thickness = 0.015) {
  return useMemo(
    () =>
      new THREE.ShaderMaterial({
        uniforms: {
          thickness: { value: thickness },
          outlineColor: { value: new THREE.Color(color) },
        },
        vertexShader: VERTEX_SHADER,
        fragmentShader: FRAGMENT_SHADER,
        side: THREE.BackSide,
      }),
    [color, thickness],
  );
}
